import { useEffect } from "react";
import { Formik, Form, getIn } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import FormControl from "components/global/form/FormControl";
import { pay_inventory } from 'redux/actions/inventoryActions';
import MultiSelect from './inputinstallment/MultiSelect';
import InputDate from './inputinstallment/inputDate';
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import toast from "react-hot-toast";
import SelectInventory  from './inputinstallment/SelectInventory';
import { useLocation } from "react-router-dom";
import SingleInventoryCard  from './inputinstallment/SingleInventoryCard'
import {setDocinventoryExtraDetails} from 'redux/slices/inventorySlice'
import BlockSelect   from  './inputinstallment/BlockSelect';
import ProjectSelect   from './inputinstallment/ProjectSelect';
import {setDoc} from 'redux/slices/inventorySlice'
import Axios from "config/api";
import { useQuery } from "react-query";
import moment from "moment";

const validationSchema = Yup.object().shape({
  mainAmount: Yup.number()
    .required("Total Amount is required")
    .min(1, "Total Amount must be greater than 0"),

  receiptDate: Yup.date().required("Receipt date is required"),

  // receiptNo: Yup.number()
  //   .required("Receipt No is required"),



  project: Yup.string()
    .when([], {
      is: () => window.location.pathname.includes("/inventory/bulk/"),
      then: schema => schema.required("Project is required"),
      otherwise: schema => schema.notRequired()
    }),

  sector: Yup.string()
    .when([], {
      is: () => window.location.pathname.includes("/inventory/bulk/"),
      then: schema => schema.required("Sector is required"),
      otherwise: schema => schema.notRequired()
    }),

  selectedInventory: Yup.mixed().when([], {
    is: () => window.location.pathname.includes("/inventory/bulk/"),
    then: schema => schema.required("Inventory is required"),
    otherwise: schema => schema.notRequired()
  }),

  parts: Yup.array()
    .of(
      Yup.object().shape({
        amount: Yup.number()
          .required("Amount is required")
          .min(1, "Amount must be greater than 0"),

        paidAt: Yup.date()
          .required("Paid date is required"),

        reference: Yup.string().nullable()
      })
    )
    .min(1, "At least one payment method is required"),

  notes: Yup.string().nullable(),
  files: Yup.array()
}).test("parts-total", "Payment parts must equal the total amount", function (values) {
  const total = (values?.parts || []).reduce((sum, part) => sum + Number(part.amount || 0), 0);
  if (Math.abs(total - Number(values?.mainAmount || 0)) <= 0.01) return true;
  return this.createError({ path: "mainAmount", message: "Payment parts must equal the total amount" });
});

const getToday = () => {
  const today = new Date();
  const pad = (value) => String(value).padStart(2, "0");
  return `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
};

const initValues = {
  mainAmount: '',
    project:'',
  sector:'',
  receiptNo: '',
  receiptDate: getToday(),
  parts: [],
  notes: "",
  files: [],
    selectedInventory: null, 

};

const PayInventoryForm = () => {
  const { id } = useParams();
    const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();

       const { doc} = useSelector(state => state.inventory);
      //  console.log('docInventory  docInventory',doc)

  const isBulkInventory = location.pathname.includes('/inventory/bulk/');
  useEffect(() => {
    if (isBulkInventory) {
      dispatch(setDocinventoryExtraDetails(null));
      dispatch(setDoc(null));
    }
  }, [isBulkInventory, dispatch]);

  const { payInvetoryLoading,docinventoryExtraDetails } = useSelector((state) => state.inventory);

  const validateForm = async (values) => {
    try {
      await validationSchema.validate(values, { abortEarly: false });
      return {}; 
    } catch (err) {
      const errors = {};

      err.inner.forEach((e) => {
        errors[e.path] = e.message;
        toast.error(e.message);
      });

      return errors;
    }
  };






  
  
  
     const { data } = useQuery(
          ["single-inventory", id],
          () => Axios(`/inventory/${id}`),
          { enabled: !isBulkInventory && Boolean(id) }
        );
      
        useEffect(() => {
          const d = data?.data?.data?.doc;
          if (!d) return;
          dispatch(setDoc(d));
        }, [data, dispatch]);
      
  
  


  const formatDate = (date) => {
    return moment(date).format("DD-MMM-YYYY");
    // const d = new Date(date);
    // const pad = (n) => n.toString().padStart(2, "0");
    // return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  };

  // const distributeAmounts = (selectedMethods, mainAmount, currentParts = []) => {
  //   if (!mainAmount || selectedMethods.length === 0) return [];

  //   const amountPerMethod = (parseFloat(mainAmount) / selectedMethods.length).toFixed(2);

  //   return selectedMethods.map(method => {
  //     const existingPart = currentParts.find(part => part.method === method);

  //     return {
  //       method: method,
  //       amount: amountPerMethod, 
  //       paidAt: existingPart ? existingPart.paidAt : "",
  //       reference: existingPart ? existingPart.reference : "",
  //     };
  //   });
  // };

// SELECT METHOD
const handleMethodSelect = (selectedMethod, formik) => {
  const exists = formik.values.parts.some(
    (p) => p.method === selectedMethod.value
  );

  if (!exists) {
    const newPart = {
      method: selectedMethod.value,
      amount: "",
      paidAt: "",
      reference: "",
    };
    formik.setFieldValue("parts", [...formik.values.parts, newPart]);
  }
};

const handleMethodRemove = (removedMethod, formik) => {
  const filteredParts = formik.values.parts.filter(
    (p) => p.method !== removedMethod.value
  );
  formik.setFieldValue("parts", filteredParts);
};

  // const handleMethodRemove = (removedMethod, formik) => {
  //   const newMethods = formik.values.parts
  //     .map(p => p.method)
  //     .filter(method => method !== removedMethod.value);

  //   const filteredParts = formik.values.parts.filter(p => p.method !== removedMethod.value);
    
  //   const distributedParts = distributeAmounts(
  //     newMethods,
  //     formik.values.mainAmount,
  //     filteredParts
  //   );

  //   formik.setFieldValue("parts", distributedParts);
  // };

  // const handleMainAmountChange = (e, formik) => {
  //   formik.handleChange(e);
    
  //   if (formik.values.parts.length > 0) {
  //     const mainAmount = e.target.value;
  //     const selectedMethods = formik.values.parts.map(part => part.method);
  //     const distributedParts = distributeAmounts(
  //       selectedMethods,
  //       mainAmount,
  //       formik.values.parts
  //     );
  //     formik.setFieldValue("parts", distributedParts);
  //   }
  // };
    const handleInventorySelect = (inventory, formik) => {
    formik.setFieldValue("selectedInventory", inventory);
  };



  const handleSubmit = async (values, { resetForm }) => {
    const errors = await validateForm(values);

    if (Object.keys(errors).length > 0) {
      return; 
    }

    try {
      let inventoryId;
      if (isBulkInventory) {
      
        inventoryId = values.selectedInventory?._id;
      } else {
   
        inventoryId = id;
      }

      if (!inventoryId) {
        toast.error("Inventory ID is required");
        return;
      }

      const formattedValues = {
        inventory: inventoryId,
        receiptNo: values?.receiptNo?.toString() || "",
        receiptDate: values.receiptDate,
        totalAmount: Number(values?.mainAmount),
        parts: values.parts.map(p => ({
          method: p.method,
          amount: Number(p.amount),
          paidAt: formatDate(p.paidAt),
          reference: p.reference || "",
        })),
        notes: values.notes || "",
        files: values.files || []
      };

      console.log("Submitted Values:", formattedValues);
      await dispatch(pay_inventory(formattedValues, navigate));
      resetForm();
    } catch (error) {
      // The action displays the API error; keep the entered values for correction.
    }
  };


  const paymentOptions = [
    { label: "Online Transfer", value: "online_transfer" },
    { label: "Cheque", value: "cheque" },
    { label: "Cheque1", value: "cheque1" },
    { label: "Cheque2", value: "cheque2" },
    { label: "Cheque3", value: "cheque3" },
    { label: "Pay Order", value: "pay_order" },
    { label: "Cash", value: "cash" },
    { label: "Other", value: "other" },
  ];

  const parseNumber = (value = "") =>
  value.replace(/,/g, "").replace(/[^\d.]/g, "");

const formatNumber = (value) => {
  if (value === "" || value === null || value === undefined) return "";
  const raw = String(value).replace(/,/g, "");
  if (raw === "" || raw === ".") return raw;

  const [intPart, decPart] = raw.split(".");
  const intFormatted = Number(intPart || 0).toLocaleString("en-US");
  return decPart !== undefined ? `${intFormatted}.${decPart}` : intFormatted;
};

  return (
    <div className="w-full flex flex-col gap-6 px-3 pb-4">
      <Formik
        initialValues={initValues}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <Form className="flex flex-col gap-6">
            <div className="flex flex-col gap-5 px-3 w-full">
              <p className="form-title">Pay Inventory </p>
              <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-5">
                 {isBulkInventory && (  
                  <>

              
                        <ProjectSelect
                      label="Select Project"
                      name="project"
                      formik={formik}
                    />

                          <BlockSelect 
                              label="Select Sector"
                              name="sector"
                              formik={formik}
                              project={formik.values.project}
                            />
                  <SelectInventory 
                    label="Select Inventory"
                      project={formik.values.project}  
                  sector={formik.values.sector}  
                    value={formik.values.selectedInventory}
                    onSelect={(inventory) => handleInventorySelect(inventory, formik)}
                    error={formik.errors.selectedInventory && formik.touched.selectedInventory ? formik.errors.selectedInventory : null}
             disabled={!formik.values.project || !formik.values.sector}
                  />

                              
    </> 
                )}

                <FormControl
                  control="input"
                  type="text"
                  inputMode="decimal"
                  label="Total Amount to Pay"
                  name="mainAmount"
                  formik={formik}
                  autoComplete="off"
                  autoCapitalize="off"
                  spellCheck={false}
                  value={formatNumber(formik.values.mainAmount)}
                  onChange={(e) => formik.setFieldValue("mainAmount", parseNumber(e.target.value))}
                />
                   

                <FormControl control="input" type="text" label="Receipt No" name="receiptNo" formik={formik} autoComplete="off" autoCapitalize="off" spellCheck={false} />
                <FormControl control="input" type="date" label="Receipt Date" name="receiptDate" formik={formik} />

                <MultiSelect
                  label="Payment Method"
                  name="parts"
                  formik={formik}
                  options={paymentOptions}
                  onSelect={(selectedMethod) => handleMethodSelect(selectedMethod, formik)}
                  onRemove={(removedMethod) => handleMethodRemove(removedMethod, formik)}
                />
              </div>

              {formik.values.parts?.map((part, index) => (
                <div key={index} className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5 mt-4">
                  <FormControl
                    control="input"
                    type="text"
                    label="Paid By"
                    name={`parts[${index}].method`}
                    formik={formik}
                    value={getIn(formik.values, `parts[${index}].method`)}
                    onChange={formik.handleChange}
                    readOnly
                  />
                  <FormControl
                    control="input"
                    type="text"
                    label="Reference #"
                    name={`parts[${index}].reference`}
                    formik={formik}
                    value={getIn(formik.values, `parts[${index}].reference`)}
                    onChange={formik.handleChange}
                  />
                   <FormControl
                      control="input"
                      type="text" 
                      inputMode="decimal"
                      label="Paid Amount"
                      name={`parts[${index}].amount`}
                      formik={formik}
                      value={formatNumber(getIn(formik.values, `parts[${index}].amount`))}
                      onChange={(e) =>
                        formik.setFieldValue(
                          `parts[${index}].amount`,
                          parseNumber(e.target.value)
                        )
                      }
                      onBlur={formik.handleBlur}
                      step="0.01"
                    />
                  {/* <FormControl
                    control="input"
                    type="number"
                    label="Paid Amount"
                    name={`parts[${index}].amount`}
                    formik={formik}
                    value={getIn(formik.values, `parts[${index}].amount`)}
                    onChange={formik.handleChange}
                    step="0.01"
                  /> */}
                  <InputDate
                    label="Paid Date"
                    name={`parts[${index}].paidAt`}
                    formik={formik}
                    // value={getIn(formik.values, `parts[${index}].paidAt`)}
                    onChange={formik.handleChange}
                  />
                </div>
              ))}

              
                  {doc && (

       <div className="sm:col-span-2">
    <SingleInventoryCard data={doc} />
</div>     
 )}

       {docinventoryExtraDetails && isBulkInventory && formik.values.selectedInventory?._id === docinventoryExtraDetails?._id && (
  <div className="sm:col-span-2">
    <SingleInventoryCard data={docinventoryExtraDetails} />
  </div>
)}

   <FormControl
              control="textarea"
              type="text"
              label="Notes"
              name="notes"
              formik={formik}
            />
           <FormControl
    control="multi-file-base64"
    label="Add Files (Optional)"
    name="files"
    formik={formik}
/>
            </div>






         


            {/* Buttons */}
            <div className="px-3 w-full flex justify-center">
              <div className="flex items-center gap-2">
                <button type="button" className="btn-secondary text-sm xs:text-base w-fit md:w-[148px]" onClick={() => formik.resetForm()}>
                  Clear
                </button>
                <button type="submit" className="btn-primary py-2 xl:px-12 px-6 text-sm xs:text-base w-fit" disabled={payInvetoryLoading}>
                  {payInvetoryLoading ? <PulseLoader size={12} color='white' /> : "Submit"}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PayInventoryForm;
